import {
  createApi,
  fetchBaseQuery
} from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_SERVER_NAME as string;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("userToken");
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: () => ({
  })
});
